/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Go Chat Notification API
 * API for managing user notifications in Go Chat application
 * OpenAPI spec version: 1.0
 */
import { faker } from '@faker-js/faker';

import { HttpResponse, delay, http } from 'msw';

import { createNotificationInstance } from '../../api-instance';
import type { BodyType } from '../../api-instance';
export interface Notification {
  id?: string;
  user_id: string;
  title: string;
  message: string;
  read?: boolean;
  created_at?: string;
  content: string;
}

export interface NotificationRequest {
  user_id: string;
  title: string;
  message: string;
  content: string;
}

export interface UnreadCountResponse {
  unread_count: number;
}

export interface Error {
  code: string;
  details: string;
}

export type GetNotificationsParams = {
  /**
   * Number of items to return
   */
  limit?: number;
  /**
   * Pagination offset
   */
  offset?: number;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns paginated list of user notifications
 * @summary Get user notifications
 */
export const getNotifications = (
  params?: GetNotificationsParams,
  options?: SecondParameter<typeof createNotificationInstance>
) => {
  return createNotificationInstance<Notification[]>(
    { url: `/notifications`, method: 'GET', params },
    options
  );
};

/**
 * Create new notification for user
 * @summary Create notification
 */
export const postNotifications = (
  notificationRequest: BodyType<NotificationRequest>,
  options?: SecondParameter<typeof createNotificationInstance>
) => {
  return createNotificationInstance<Notification>(
    {
      url: `/notifications`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: notificationRequest,
    },
    options
  );
};

/**
 * Updates notification by setting read_at to current time
 * @summary Mark notification as read
 */
export const markNotificationAsRead = (
  notificationId: string,
  options?: SecondParameter<typeof createNotificationInstance>
) => {
  return createNotificationInstance<void>(
    { url: `/notifications/${notificationId}`, method: 'PATCH' },
    options
  );
};

/**
 * Returns count of unread notifications
 * @summary Get unread count
 */
export const getNotificationsUnread = (
  options?: SecondParameter<typeof createNotificationInstance>
) => {
  return createNotificationInstance<UnreadCountResponse>(
    { url: `/notifications/unread`, method: 'GET' },
    options
  );
};

export type GetNotificationsResult = NonNullable<
  Awaited<ReturnType<typeof getNotifications>>
>;
export type PostNotificationsResult = NonNullable<
  Awaited<ReturnType<typeof postNotifications>>
>;
export type MarkNotificationAsReadResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationAsRead>>
>;
export type GetNotificationsUnreadResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationsUnread>>
>;

export const getGetNotificationsResponseMock = (): Notification[] =>
  Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
    user_id: faker.string.alpha(20),
    title: faker.string.alpha(20),
    message: faker.string.alpha(20),
    read: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
    created_at: faker.helpers.arrayElement([
      `${faker.date.past().toISOString().split('.')[0]}Z`,
      undefined,
    ]),
    content: faker.string.alpha(20),
  }));

export const getPostNotificationsResponseMock = (
  overrideResponse: Partial<Notification> = {}
): Notification => ({
  id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
  user_id: faker.string.alpha(20),
  title: faker.string.alpha(20),
  message: faker.string.alpha(20),
  read: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  created_at: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  content: faker.string.alpha(20),
  ...overrideResponse,
});

export const getGetNotificationsUnreadResponseMock = (
  overrideResponse: Partial<UnreadCountResponse> = {}
): UnreadCountResponse => ({
  unread_count: faker.number.int({ min: undefined, max: undefined }),
  ...overrideResponse,
});

export const getGetNotificationsMockHandler = (
  overrideResponse?:
    | Notification[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<Notification[]> | Notification[])
) => {
  return http.get('*/notifications', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetNotificationsResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getPostNotificationsMockHandler = (
  overrideResponse?:
    | Notification
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<Notification> | Notification)
) => {
  return http.post('*/notifications', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getPostNotificationsResponseMock()
      ),
      { status: 201, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getMarkNotificationAsReadMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0]
      ) => Promise<void> | void)
) => {
  return http.patch('*/notifications/:notificationId', async (info) => {
    await delay(1000);
    if (typeof overrideResponse === 'function') {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 204 });
  });
};

export const getGetNotificationsUnreadMockHandler = (
  overrideResponse?:
    | UnreadCountResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<UnreadCountResponse> | UnreadCountResponse)
) => {
  return http.get('*/notifications/unread', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetNotificationsUnreadResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};
export const getGoChatNotificationAPIMock = () => [
  getGetNotificationsMockHandler(),
  getPostNotificationsMockHandler(),
  getMarkNotificationAsReadMockHandler(),
  getGetNotificationsUnreadMockHandler(),
];
